import { __assign, __read, __rest } from "tslib";
import React, { useState } from "react";
import moment from "moment";
import CalendarPart from "./CalendarPart";
import { useDefaultValue } from "../form/controlled";
import { CalendarTable } from "./CalendarTable";
import { useTranslation } from "../i18n";
import { mergeEventProps } from "../_util/merge-event-props";
export var Calendar = React.forwardRef(function Calendar(props, ref) {
    useTranslation(moment);
    var _a = useDefaultValue(props), className = _a.className, style = _a.style, restProps = __rest(_a, ["className", "style"]);
    var _b = __read(useState("date"), 2), type = _b[0], setType = _b[1];
    var value = props.value;
    var _c = __read(useState(moment.isMoment(value) ? value : moment()), 2), curViewMoment = _c[0], setCurViewMoment = _c[1];
    return (React.createElement(CalendarPart.Panel, __assign({ ref: ref, className: className, style: style }, mergeEventProps(props)),
        React.createElement(CalendarPart.Body, null,
            React.createElement(CalendarTable, __assign({}, restProps, { curViewMoment: curViewMoment, onCurViewMomentChange: setCurViewMoment, type: type, onTypeChange: setType })))));
});
Calendar.displayName = "Calendar";
//# sourceMappingURL=Calendar.js.map